export default __webpack_public_path__ + "static/media/c002-example1.588c5b5a.jpg";